import React from "react";
import { useMap } from "react-map-gl";
import { useSelector } from "react-redux";

import { TreeEventLayer, TreeLineEventLayer, BuildingEventLayer } from "./";

const ShadeLayer = ({ interactive = true }) => {
  const { current: mapRef } = useMap();

  const shade_objects = useSelector((state) => state.canopy.shade_objects);

  return (
    <>
      {shade_objects &&
        Object.values(shade_objects)?.length > 0 &&
        Object.values(shade_objects)?.map((shade) => {
          if (shade.shape === "tree") {
            console.log("shape", shade);
            return <TreeEventLayer key={shade.id} id={shade.id} interactive={interactive} />;
          } else if (shade.shape === "treeLine") {
            return <TreeLineEventLayer key={shade.id} id={shade.id} interactive={interactive} />;
          } else {
            return <BuildingEventLayer key={shade.id} id={shade.id} interactive={interactive} />;
          }
        })}
    </>
  );
};

export { ShadeLayer };
